import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TextInput } from '../..';

export const NumberMaxValueValidator: () => ValidatorFn = () => {
    return (control: AbstractControl): ValidationErrors | null => {
        const internalControl = control as TextInput;
        if (internalControl.value && internalControl.max) {
            const num = parseFloat(internalControl.value);
            if (num > internalControl?.max) {
                return { number_after_max: true };
            } else {
                return null;
            }
        }
        return null;
    };
};
